if (!customElements.get('gallery-scroll-indicator')) {
  customElements.define('gallery-scroll-indicator', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.parentElement.querySelector('.product__media-list');
      if (!this.slider) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.slider.addEventListener('scroll', this.schedule, { passive: true });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.slider);
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.slider, { childList: true, subtree: true });
      this.update();
    }

    update() {
      const slides = [...this.slider.querySelectorAll('.product__media-item')].filter(slide => slide.clientWidth > 0);
      const count = slides.length;
      const distance = this.slider.scrollWidth - this.slider.clientWidth;
      this.hidden = count < 2 || distance <= 1;
      if (this.hidden) return;
      const progress = Math.max(0, Math.min(1, Math.abs(this.slider.scrollLeft) / distance));
      this.style.setProperty('--indicator-width', `${100 / count}%`);
      this.style.setProperty('--indicator-position', `${progress * (100 - 100 / count)}%`);
      const current = slides.reduce((nearest, slide, index) =>
        Math.abs(slide.getBoundingClientRect().left - this.slider.getBoundingClientRect().left) <
        Math.abs(slides[nearest].getBoundingClientRect().left - this.slider.getBoundingClientRect().left) ? index : nearest, 0);
      this.setAttribute('aria-valuemax', count);
      this.setAttribute('aria-valuenow', current + 1);
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.schedule);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
